"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageService = void 0;
const tsyringe_1 = require("tsyringe");
const eventemitter3_1 = require("eventemitter3");
let MessageService = class MessageService {
    constructor() {
        this.messages = new eventemitter3_1.EventEmitter();
        this.messageEvent = (cb) => {
            this.messages.on('spkz-message', cb);
        };
        this.emitMessage = (message) => {
            this.messages.emit('spkz-message', message);
        };
    }
};
MessageService = __decorate([
    tsyringe_1.scoped(tsyringe_1.Lifecycle.ContainerScoped)
], MessageService);
exports.MessageService = MessageService;
//# sourceMappingURL=messageService.js.map